export enum DISTRIBUTION_ORDER_STATES {
  INCOMPLETE = 'INCOMPLETE',
  COMPLETED = 'COMPLETED',
  ISSUED = 'ISSUED',
  CLOSED = 'CLOSED',
  PROCESSING = 'PROCESSING',
}
